function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.59569 17.1023V3.48668C2.59569 3.1824 2.72241 2.89179 2.94549 2.68473C3.16857 2.47767 3.46794 2.37297 3.77137 2.39562L11.3086 2.95974V18.7695L3.60812 18.1934C3.03823 18.1485 2.59783 17.6739 2.59569 17.1023Z",
  fill: "#9298A8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.394495 4.41684C0.644289 4.20871 0.973787 4.1226 1.29346 4.18243C1.29965 4.18371 1.30606 4.18456 1.31226 4.18563L1.5018 4.21405V17.1023C1.50628 18.2457 2.38666 19.1945 3.52644 19.2842L11.815 19.9045C11.8284 19.9056 11.8421 19.906 11.8558 19.906C11.8695 19.906 11.8831 19.9056 11.8966 19.9045L20.1849 19.2842C21.3247 19.1945 22.2053 18.2457 22.2098 17.1023V4.26469L22.7027 4.17944L22.7083 4.17837C23.0277 4.11982 23.3566 4.20593 23.6062 4.41384C23.8558 4.62176 24 4.92967 24 5.25447V19.4575C24.0017 20.021 23.5737 20.4928 23.0128 20.546L12.2671 21.6007C12.0893 21.6183 11.9105 21.6183 11.7327 21.6007L0.987249 20.5462C0.426334 20.493 -0.00167274 20.0212 3.62396e-05 19.4577V5.2581C-0.00060463 4.93288 0.14406 4.62454 0.394495 4.41684Z",
  fill: "#9298A8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.103 18.1934L12.4023 18.7695V2.95975L19.9396 2.39563C19.968 2.39349 19.9962 2.39243 20.024 2.39243C20.6272 2.39392 21.1152 2.88325 21.1152 3.48648V17.1021C21.1133 17.6737 20.6729 18.1485 20.103 18.1934Z",
  fill: "#9298A8"
});

var SvgPaket = function SvgPaket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paket.19527781.svg";
export { ForwardRef as ReactComponent };